/**
 * @todo [web-browser-adapter]  Remove all usages of @apply, and remove this
 *                              shim. mainly to improve performance and dev
 *                              experience.
 */
import '@webcomponents/shadycss/apply-shim.min';

import { autorun } from 'mobx';

import { LitElement, html, css, unsafeCSS } from 'lit';
import { customElement } from 'lit/decorators/custom-element.js';
import { property } from 'lit/decorators/property.js';

import application from '../store';

const RELATIVE_URI = import.meta.url.split('/').slice(0, -2).join('/');

/**
 * A shell for quéntar applets.
 *
 * @todo [web-browser-adapter]  Dispose autorun reactor when reloading.
 * @todo [web-browser-adapter]  Use a simple router to resolve graphical
 *                              interface elements.
 */
@customElement('neurau-app')
export default class NeurauApp extends LitElement {
  static styles = css`
    :host {
      display: contents;
    }

    :host > :not([active]) {
      display: none;
    }

    :host > :not(:defined)::before {
      content: url('${unsafeCSS(`${RELATIVE_URI}/assets/two-dots.svg`)}');

      place-content: center;
      display: grid;

      position: absolute;
      inset: 0;
    }
  `;

  /** @todo [quentar-elements]  Document why this configuration exists. */
  static shadowRootOptions = {
    ...LitElement.shadowRootOptions,
    delegatesFocus: true,
  };

  @property({ type: String, attribute: false })
  accessor selectedApplet;

  constructor() {
    super();

    autorun(
      async ({ name }) => {
        if (application.selectedApplet === null) {
          return console.warn(`${name}: no applet selected`);
        }
        this.selectedApplet = application.selectedApplet;
        await this.updateComplete;

        return this.ownerDocument.defaultView.customElements
          .whenDefined(`${application.selectedApplet}-applet`)
          .then(() => {
            const applet = this.shadowRoot.querySelector(
              `${application.selectedApplet}-applet`,
            );
            return application.flushFirstPaintState(applet.ownerStore);
          });
      },
      { name: 'application::applet selection' },
    );
  }

  render() {
    return html`
      <neurau-employee-applet
        class="applet"
        ?active="${this.selectedApplet === 'neurau-employee'}"
      >
        <slot slot="overlay"></slot>
      </neurau-employee-applet>
    `;
  }
}
